var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Colors, Dimensions } from '@hawkins/variables';
var PhaseColorMapping = {
    ARCHIVAL_DELIVERY: Colors.Green400,
    COMPLETE: Colors.Green700,
    DEAD: Colors.Red600,
    DEVELOPMENT: Colors.Purple600,
    INCOMPLETE: Colors.Gray500,
    LAUNCH_PREP: Colors.Green700,
    LAUNCHED: Colors.Green900,
    NOT_STARTED: Colors.Gray500,
    OPTION: Colors.Orange600,
    PITCH: Colors.Yellow700,
    POSTPRODUCTION: Colors.Cyan700,
    PREPRODUCTION: Colors.Violet500,
    PRODUCTION: Colors.Blue600,
    SEASON_RENEWAL: Colors.Gray500,
    TENTATIVE: Colors.Pink600,
    UNKNOWN: Colors.Gray500,
};
export function getProductionPhaseColor(phase) {
    return PhaseColorMapping[phase];
}
// Patch in some new properties to extend the colors
export var patchedColors = __assign(__assign(__assign({}, Colors), {
    COMPLETE: Colors.Green,
    FAILURE: Colors.Red,
    IN_PROGRESS: Colors.Yellow,
    // Statuses
    NEW: Colors.Indigo,
}), PhaseColorMapping);
var getStyleValue = function (value, newVariables) {
    if (newVariables[value]) {
        return newVariables[value];
    }
    return value;
};
export var getComputedStyleFromLayoutProps = function (style, layoutProps) {
    if (style === void 0) { style = {}; }
    if (layoutProps === void 0) { layoutProps = {}; }
    var computedStyle = __assign({}, style);
    Object.keys(layoutProps).forEach(function (prop) {
        switch (prop) {
            case 'color':
            case 'fill':
            case 'backgroundColor':
                computedStyle[prop] = getStyleValue(layoutProps[prop], patchedColors);
                break;
            case 'gap':
            case 'rowGap':
            case 'columnGap':
            case 'margin':
            case 'marginTop':
            case 'marginRight':
            case 'marginBottom':
            case 'marginLeft':
            case 'padding':
            case 'paddingTop':
            case 'paddingRight':
            case 'paddingBottom':
            case 'paddingLeft':
                computedStyle[prop] = getStyleValue(layoutProps[prop], Dimensions);
                break;
            case 'paddingX': {
                var paddingXValue = getStyleValue(layoutProps[prop], Dimensions);
                computedStyle.paddingLeft = paddingXValue;
                computedStyle.paddingRight = paddingXValue;
                break;
            }
            case 'paddingY': {
                var paddingYValue = getStyleValue(layoutProps[prop], Dimensions);
                computedStyle.paddingTop = paddingYValue;
                computedStyle.paddingBottom = paddingYValue;
                break;
            }
            case 'marginX': {
                var marginXValue = getStyleValue(layoutProps[prop], Dimensions);
                computedStyle.marginLeft = marginXValue;
                computedStyle.marginRight = marginXValue;
                break;
            }
            case 'marginY': {
                var marginYValue = getStyleValue(layoutProps[prop], Dimensions);
                computedStyle.marginTop = marginYValue;
                computedStyle.marginBottom = marginYValue;
                break;
            }
            case 'width':
            case 'minWidth':
            case 'maxWidth':
            case 'height':
            case 'minHeight':
            case 'maxHeight':
                computedStyle[prop] = getStyleValue(layoutProps[prop], Dimensions);
                break;
            case 'borderRadius':
                computedStyle[prop] = getStyleValue(layoutProps[prop], Dimensions);
                break;
            case 'borderColor':
                computedStyle[prop] = getStyleValue(layoutProps[prop], patchedColors);
                break;
            case 'borderWidth':
                computedStyle[prop] = getStyleValue(layoutProps[prop], Dimensions);
                break;
            case 'borderStyle':
            case 'display':
            case 'position':
            case 'overflow':
            case 'textOverflow':
            case 'visibility':
            case 'whiteSpace':
            case 'flexBasis':
            case 'flexDirection':
            case 'flexWrap':
            case 'justifyContent':
            case 'alignItems':
            case 'alignContent':
            case 'order':
            case 'flex':
            case 'flexGrow':
            case 'flexShrink':
            case 'alignSelf':
            case 'justifyItems':
            case 'justifySelf':
            case 'gridTemplateColumns':
            case 'gridTemplateRows':
            case 'gridColumnStart':
            case 'gridColumnEnd':
            case 'gridRowEnd':
            case 'gridRowStart':
            case 'gridTemplateAreas':
            case 'gridArea':
            case 'gridTemplate':
            case 'placeItems':
            case 'placeContent':
            case 'gridAutoColumns':
            case 'gridAutoRows':
            case 'gridAutoFlow':
            case 'gridColumn':
            case 'gridRow':
            case 'grid':
            case 'placeSelf':
            case 'border':
            case 'borderTop':
            case 'borderRight':
            case 'borderBottom':
            case 'borderLeft':
                computedStyle[prop] = layoutProps[prop];
                break;
            default:
                // No op since the props could be non-layout props too
                break;
        }
    });
    return computedStyle;
};
//# sourceMappingURL=computeStyle.js.map